function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const SupportIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0zm-6 16c0-3.3 2.7-6 6-6s6 2.7 6 6-2.7 6-6 6-6-2.7-6-6zm18.9 5.4l-5.5-2.3c.4-.9.6-2 .6-3.1s-.2-2.1-.6-3.1l5.5-2.3c.7 1.7 1.1 3.5 1.1 5.4s-.4 3.7-1.1 5.4zM21.4 3.1l-2.3 5.5c-1-.4-2-.6-3.1-.6s-2.1.2-3.1.6l-2.3-5.5C12.3 2.4 14.1 2 16 2s3.7.4 5.4 1.1zM3.1 10.6l5.5 2.3c-.4 1-.6 2-.6 3.1s.2 2.1.6 3.1l-5.5 2.3C2.4 19.7 2 17.9 2 16s.4-3.7 1.1-5.4zm7.5 18.3l2.3-5.5c.9.4 2 .6 3.1.6s2.1-.2 3.1-.6l2.3 5.5c-1.7.7-3.5 1.1-5.4 1.1s-3.7-.4-5.4-1.1z"
  }));
};
export default SupportIcon;